import { DAPI_TOKEN, REFRESH_TOKEN_TIMEOUT, LOGIN_INFO_COOKIE_NAME } from '../../config';
import { getLoginInfo } from '../session';
import { refreshResponseReceived, loginFailed } from '../../actions/login';
import { postLoginRefresh } from '../dapi/login';
import { isEmptyObject } from '../util/object';
import { setLoginInfo } from '../session';

const getAccountId = () => {
  const returningUserCookie = getLoginInfo();
  return returningUserCookie ? returningUserCookie.id : null;
};

const publicAuthHeaders = () => ({
  Authorization: `Bearer ${DAPI_TOKEN}`,
});

const getLoggedInAuthHeaders = () => {
  const returningUserCookie = getLoginInfo();
  if (returningUserCookie) {
    return {
      Authorization: `${returningUserCookie.tokenType} ${returningUserCookie.authToken}`,
    };
  }
  return null;
};

// token type is not defined if login has not been called
const authHeaders = () => {
  const returningUserCookie = getLoginInfo();
  return returningUserCookie && returningUserCookie.tokenType
    ? getLoggedInAuthHeaders()
    : publicAuthHeaders();
};

const getAuthToken = () => {
  const returningUserCookie = getLoginInfo();

  return returningUserCookie ? `Bearer ${returningUserCookie.authToken}` : null;
};

const refreshToken = (context, cookies) => {
  const loginStore = context.store.getState().login;

  const loginCredentials = cookies.get(LOGIN_INFO_COOKIE_NAME);
  if (!isEmptyObject(loginCredentials) && loginCredentials.persisted) {
    // Nothing to refresh here.
    // Having to log back in every 100 years (current long session duration) is fine.
    return;
  }

  if (
    !isEmptyObject(loginStore) &&
    !isEmptyObject(loginStore.login) &&
    loginStore.login.refresh_token &&
    !loginStore.error
  ) {
    const handleRefreshSuccess = response => {
      const currentLoginInfo = getLoginInfo();
      setLoginInfo(
        {
          account_id: currentLoginInfo.id,
          ...response,
        },
        cookies
      );
      return refreshResponseReceived(response);
    };

    context.store.dispatch(postLoginRefresh(loginStore.login, handleRefreshSuccess, loginFailed));
  }
};

const keepAccessTokenRefreshed = (context, cookies) =>
  window.setInterval(() => refreshToken(context, cookies), REFRESH_TOKEN_TIMEOUT);

export { authHeaders, getAccountId, keepAccessTokenRefreshed, getAuthToken };
